import {ContingentBeneficiary, ValidContingentBeneficiary} from 'ApplicationEntry/models/ContingentBeneficiary';
import {
  EmptyContingentBeneficiaryList,
  ValidContingentBeneficiaryList,
} from 'ApplicationEntry/models/ContingentBeneficiaryList';
import {ValidDependentList} from 'ApplicationEntry/models/DependentLists';
import {Dependents, ValidDependents} from 'ApplicationEntry/models/Dependents';
import {EmptyPhoneNumber, ValidPhoneNumber} from 'ApplicationEntry/models/PhoneNumber';
import {PrimaryBeneficiary, ValidPrimaryBeneficiary} from 'ApplicationEntry/models/PrimaryBeneficiary';
import {EmptyPrimaryBeneficiaryList, ValidPrimaryBeneficiaryList} from 'ApplicationEntry/models/PrimaryBeneficiaryList';
import {EmptySocialSecurityNumber, ValidSocialSecurityNumber} from 'ApplicationEntry/models/SocialSecurityNumber';
import {EmptyZipCode, ValidZipCode} from 'ApplicationEntry/models/ZipCode';
import {NonEmptyString} from 'Core/models/EmptyString';
import DateUtility from 'Shared/utilities/DateUtility';
import * as I from 'immutable';

export const getPrimaryBeneficiaries = (beneficiaryList: object[]) => {
  let primaryBeneficiaryInfoList = I.List<PrimaryBeneficiary>();
  const getDate = (date: string) => {
    var partDateValueArr: string[] = [];
    var parts = date?.split('-');
    partDateValueArr?.push(parts[0]);
    partDateValueArr?.push(parts[1]);
    if (parts[2]?.includes('T')) {
      let partdt = parts[2].split('T');
      partDateValueArr.push(partdt[0]);
    } else {
      partDateValueArr.push(parts[2]);
    }
    return partDateValueArr;
  };
  if (beneficiaryList?.length > 0) {
    const primaryBeneficiaries = beneficiaryList.filter(
      beneficiary => beneficiary['personType'] === 'Primary Beneficiary'
    );

    if (primaryBeneficiaries.length > 0) {
      primaryBeneficiaries.forEach(item => {
        var partsDate = item['dateOfBirth'] && getDate(item['dateOfBirth']);
        const primaryBeneficiaryInfo = ValidPrimaryBeneficiary.create(
          NonEmptyString.create(item['firstName']),
          NonEmptyString.create(item['middleName']),
          NonEmptyString.create(item['lastName']),
          NonEmptyString.create(
            item['relationship'] === 'SPOUSE'
              ? 'Spouse'
              : item['relationship'] === 'CHILD'
              ? 'Child'
              : item['relationship'] === 'SELF'
              ? null
              : item['relationship']
          ),
          Number(item['beneficiaryPercent']),
          item['identifier'] === null || item['identifier'] === ''
            ? EmptySocialSecurityNumber
            : ValidSocialSecurityNumber.create(item['identifier']),
          partsDate ? new Date(Number(partsDate[0]), Number(partsDate[1]) - 1, Number(partsDate[2])) : '',
          item['phoneNumber'] === null || item['phoneNumber'] === ''
            ? EmptyPhoneNumber
            : ValidPhoneNumber.create(item['phoneNumber']),
          NonEmptyString.create(item['address1']),
          NonEmptyString.create(item['address2']),
          NonEmptyString.create(item['city']),
          NonEmptyString.create(item['state']),
          item['zipCode'] === null || item['zipCode'] === '' ? EmptyZipCode : ValidZipCode.create(item['zipCode']),
          NonEmptyString.create(item['occSmokerCode']),
          new Date(DateUtility.toFormattedDateAsUtc(item['signatureDate']))
        );
        primaryBeneficiaryInfoList = primaryBeneficiaryInfoList.push(primaryBeneficiaryInfo);
      });

      return ValidPrimaryBeneficiaryList.create(primaryBeneficiaryInfoList);
    }
  }
  return EmptyPrimaryBeneficiaryList;
};

export const getContingentBeneficiaryList = (beneficiaryList: object[]) => {
  let contingentBeneficiaryInfoList = I.List<ContingentBeneficiary>();
  const getDate = (date: string) => {
    var partDateValueArr: string[] = [];
    var parts = date?.split('-');
    partDateValueArr?.push(parts[0]);
    partDateValueArr?.push(parts[1]);
    if (parts[2].includes('T')) {
      let partdt = parts[2].split('T');
      partDateValueArr.push(partdt[0]);
    } else {
      partDateValueArr.push(parts[2]);
    }
    return partDateValueArr;
  };
  if (beneficiaryList?.length > 0) {
    const contingentBeneficiaries = beneficiaryList.filter(
      beneficiary => beneficiary['personType'] === 'Contingent Beneficiary'
    );

    if (contingentBeneficiaries?.length > 0) {
      contingentBeneficiaries.forEach(item => {
        var partsDate = item['dateOfBirth'] && getDate(item['dateOfBirth']);
        const contingentBeneficiaryInfo = ValidContingentBeneficiary.create(
          NonEmptyString.create(item['firstName']),
          NonEmptyString.create(item['middleName']),
          NonEmptyString.create(item['lastName']),
          NonEmptyString.create(
            item['relationship'] === 'SPOUSE'
              ? 'Spouse'
              : item['relationship'] === 'CHILD'
              ? 'Child'
              : item['relationship'] === 'SELF'
              ? null
              : item['relationship']
          ),
          Number(item['beneficiaryPercent']),
          item['identifier'] === null || item['identifier'] === ''
            ? EmptySocialSecurityNumber
            : ValidSocialSecurityNumber.create(item['identifier']),
          partsDate ? new Date(Number(partsDate[0]), Number(partsDate[1]) - 1, Number(partsDate[2])) : '',
          item['phoneNumber'] === null || item['phoneNumber'] === ''
            ? EmptyPhoneNumber
            : ValidPhoneNumber.create(item['phoneNumber']),
          NonEmptyString.create(item['address1']),
          NonEmptyString.create(item['address2']),
          NonEmptyString.create(item['city']),
          NonEmptyString.create(item['state']),
          item['zipCode'] === null || item['zipCode'] === '' ? EmptyZipCode : ValidZipCode.create(item['zipCode']),
          NonEmptyString.create(item['occSmokerCode']),
          new Date(DateUtility.toFormattedDateAsUtc(item['signatureDate']))
        );

        contingentBeneficiaryInfoList = contingentBeneficiaryInfoList.push(contingentBeneficiaryInfo);
      });
      return ValidContingentBeneficiaryList.create(contingentBeneficiaryInfoList);
    }
  }
  return EmptyContingentBeneficiaryList;
};

type ClientAddress = {
  streetAddress1: string;
  streetAddress2: string;
  city: string;
  county: string;
  state: string;
  country: string;
  zipCode: string;
};

export const getDependentList = (clients: object[]) => {
  let dependentList = I.List<Dependents>();
  const getDate = (date: string) => {
    var partDateValueArr: string[] = [];
    var parts = date?.split('-');
    partDateValueArr?.push(parts[0]);
    partDateValueArr?.push(parts[1]);
    if (parts[2]?.includes('T')) {
      let partdt = parts[2].split('T');
      partDateValueArr.push(partdt[0]);
    } else {
      partDateValueArr.push(parts[2]);
    }
    return partDateValueArr;
  };
  clients.forEach(client => {
    const clientAddress: ClientAddress = client['address'];
    if (client['dependent']) {
      var partsDate = client['dateOfBirth'] && getDate(client['dateOfBirth']);
      let firstNameandMiddleInitial: string = client['firstName'];
      let updatedFirstName = '';
      let updatedMiddleName = '';
      if (firstNameandMiddleInitial.indexOf(' ') >= 0) {
        updatedFirstName = firstNameandMiddleInitial.split(' ')[0];
        updatedMiddleName = firstNameandMiddleInitial.split(' ')[1];

        let dependent: Dependents = ValidDependents.create(
          NonEmptyString.create(updatedFirstName),
          NonEmptyString.create(updatedMiddleName),
          NonEmptyString.create(client['lastName']),
          NonEmptyString.create(
            client['relationshipToPI'] === 'SPOUSE'
              ? 'Spouse'
              : client['relationshipToPI'] === 'CHILD'
              ? 'Child'
              : client['relationshipToPI']
          ),
          client['gender'] === 'FEMALE' ? 'FEMALE' : client['gender'] === 'MALE' ? 'MALE' : '',
          client['ssn'] === null || client['ssn'] === ''
            ? EmptySocialSecurityNumber
            : ValidSocialSecurityNumber.create(client['ssn']),
          partsDate ? new Date(Number(partsDate[0]), Number(partsDate[1]) - 1, Number(partsDate[2])) : '',
          client['workPhone'] === null || client['workPhone'] === ''
            ? EmptyPhoneNumber
            : ValidPhoneNumber.create(client['workPhone']),
          NonEmptyString.create(clientAddress.streetAddress1),
          clientAddress.streetAddress2,
          NonEmptyString.create(clientAddress.city),
          NonEmptyString.create(clientAddress.state),
          ValidZipCode.create(clientAddress.zipCode),
          NonEmptyString.create(client['occSmokerCode']),
          false,
          false,
          false
        );
        dependentList = dependentList.push(dependent);
      } else {
        let dependent: Dependents = ValidDependents.create(
          NonEmptyString.create(client['firstName']),
          NonEmptyString.create(client['middleName']),
          NonEmptyString.create(client['lastName']),
          NonEmptyString.create(
            client['relationshipToPI'] === 'SPOUSE'
              ? 'Spouse'
              : client['relationshipToPI'] === 'CHILD'
              ? 'Child'
              : client['relationshipToPI']
          ),
          client['gender'] === 'FEMALE' ? 'FEMALE' : client['gender'] === 'MALE' ? 'MALE' : '',
          client['ssn'] === null || client['ssn'] === ''
            ? EmptySocialSecurityNumber
            : ValidSocialSecurityNumber.create(client['ssn']),
          partsDate ? new Date(Number(partsDate[0]), Number(partsDate[1]) - 1, Number(partsDate[2])) : '',
          client['workPhone'] === null || client['workPhone'] === ''
            ? EmptyPhoneNumber
            : ValidPhoneNumber.create(client['workPhone']),
          NonEmptyString.create(clientAddress.streetAddress1),
          clientAddress.streetAddress2,
          NonEmptyString.create(clientAddress.city),
          NonEmptyString.create(clientAddress.state),
          ValidZipCode.create(clientAddress.zipCode),
          NonEmptyString.create(client['occSmokerCode']),
          false,
          false,
          false
        );
        dependentList = dependentList.push(dependent);
      }
    }
  });
  return ValidDependentList.create(dependentList);
};
